/**
 * v0 by Vercel.
 * @see https://v0.dev/t/Tt9dxED4Mgh
 * Documentation: https://v0.dev/docs#integrating-generated-code-into-your-nextjs-app
 */

import { Button, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

export default function TerminosCondiciones() {

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black-100 p-4">
      <div className="w-full max-w-2xl">
        <div>
          <h2>
            <b>
              Términos y Condiciones
            </b>
          </h2>
        </div>
        <Grid className="text-sm text-black-700 dark:text-black-300 my-2" sx={{
          maxHeight: "70vh",
          overflowY: "scroll",
          padding: "10px 15px"
        }}>
          <p className="mb-4 whitespace-pre-line leading-[1.6]">{`
            **1. APLICABILIDAD**
            Estos Términos y Condiciones de Venta incluyen el código de conducta del guía de Ética
            Empresarial de ETIMEX, que se aplicarán a todas las ventas, órdenes de compra, contratos
            de venta, envíos y reconocimientos de órdenes de venta (cada uno, un "Pedido") de
            cualquier producto y/o servicio ("Productos") por cualquier entidad vendedora de ETIMEX,
            incluidas cualquiera de sus afiliadas o subsidiarias, ya sea en México o en otras partes
            (cada uno,
            "ETIMEX" o "VENDEDOR") y cualquier cliente ("COMPRADOR"). Todos los
            pedidos, ventas, ofertas, aceptaciones, reconocimientos de órdenes de venta, contratos de
            venta y envíos de productos están expresamente limitados y se condicionan a la
            aprobación y aceptación del COMPRADOR de estos Términos y Condiciones. ETIMEX
            limita expresamente la aceptación del COMPRADOR a estos Términos y Condiciones, y por
            la presente se notifica que ETIMEX objeta y rechaza cualquier término o condición
            contenido en cualquier orden de compra u otra comunicación de cualquier tipo del
            COMPRADOR que sea diferente, contradictoria, inconsistente con, o adicional a estos
            Términos y Condiciones.
            El Vendedor se reserva el derecho de modificar estos Términos y Condiciones
            unilateralmente según sea necesario y sin previo aviso.
            **2. PRECIO**
            A menos que se confirme lo contrario en el reconocimiento de pedido de venta de ETIMEX
            o en un acuerdo separado firmado por ETIMEX y el COMPRADOR, todos los precios son
            LAB en el punto de envío de planta ETIMEX. Todos los precios están excluidos de cualquier
            impuesto federal, estatal, provincial, local, municipal u otros impuestos presentes o futuros
            aplicables a la venta de Productos, o cualquier derecho o cargo de cualquier tipo
            impuesto por una autoridad gubernamental. Cualquier impuesto de este tipo se añadirá
            al precio y será pagado por el COMPRADOR, a menos que el COMPRADOR proporcione a
            ETIMEX un certificado de exención válido aceptable para ETIMEX y las autoridades fiscales
            correspondientes. Todos los precios están sujetos a cambios sin previo aviso; sin embargo,
            los precios serán los que figuren en la lista de precios del Vendedor correspondiente para
            los Productos pedidos y en efecto en la fecha de envío indicada en el reconocimiento de
            pedido de venta del Vendedor u otra forma de confirmación. Los pedidos para entrega
            futura se facturará a los precios vigentes en la fecha de envío. Si, a petición del
            COMPRADOR, el Vendedor se ve obligado a mantener un stock de Productos, el
            COMPRADOR es en todo momento responsable de pagar al Vendedor un importe
            equivalente al precio de los Productos en inventario, así como de cualquier materia prima
            necesaria para mantener el stock. No se efectuará ningún reembolso al COMPRADOR si el
            Acuerdo o de otro modo termina, por cualquier razón, y el stock o las materias primas
            relacionadas aún no se han vendido.
            **3. PAGO**
            El COMPRADOR será facturado solo por la cantidad realmente enviada más, si
            corresponde, la pérdida por recorte. El término de pago es neto a 30 días desde la fecha
            de la factura siempre y cuando el cliente tenga ya el crédito establecido. El tiempo es
            esencial para el pago de facturas y el pago es material para la venta o el contrato de venta
            de productos. Las facturas que no se paguen dentro de los 30 días a partir de la fecha de
            la factura acumularán un cargo por pago tardío del 1.5 % mensual sobre el saldo no
            pagado, o el monto máximo permitido por la ley, hasta que se paguen ("Cargo por pago
            tardío"). La imposición de un Cargo por pago tardío no pretende inferir ningún
            consentimiento, aquiescencia u otro acuerdo, expreso o implícito, por parte de ETIMEX
            para tolerar o de otra manera aplazar la cobranza de facturas impagadas. El COMPRADOR
            confirma, reconoce y acepta que sería difícil y costoso intentar determinar el daño real
            sufrido por ETIMEX como resultado del incumplimiento de pago de cualquier cuenta
            individual y que el cargo del 1.5% mensual mencionado anteriormente representa un
            esfuerzo razonable para fijar la pérdida mínima probable de ETIMEX resultante del retraso
            en el pago, que dicho cargo guarda una relación razonable con dicha pérdida y que el
            recargo es razonable en cantidad. En el caso de que ETIMEX utilice un agente de cobranza
            externo o inicie una acción de cobranza para recuperar una deuda, ETIMEX tendrá
            derecho a recuperar los honorarios de abogado, gastos y costos asociados con dicha
            cobranza de montos impagos.
            ETIMEX puede, sin previo aviso al COMPRADOR, retener o rechazar pedidos, retener o
            cesar envíos de pedidos confirmados, alterar o revocar términos de crédito y/o requerir
            pagos por adelantado, si ETIMEX determina a su única discreción que la condición
            financiera o el historial de pagos del COMPRADOR no justifican nuevos pedidos, el envío
            de productos o la continuación de términos de crédito. El incumplimiento del
            COMPRADOR de pagar cualquier factura de ETIMEX en su fecha de vencimiento hace que
            todas las facturas pendientes sean inmediatamente exigibles y pagaderas
            independientemente de los términos, y ETIMEX puede rechazar o retener pedidos, o
            retener entregas, hasta que la cuenta completa sea liquidada. Si ETIMEX solicita garantías
            adecuadas, el COMPRADOR proporcionará a ETIMEX, dentro de los tres días de la
            solicitud, registros comerciales que se mantengan en el curso ordinario del negocio y que
            satisfaga la requisición.
            **4. CUMPLIMIENTO DE PEDIDOS**
            La cotización del vendedor no es una oferta de venta, sino una invitación a presentar un
            pedido y no surgirá una relación contractual hasta que un pedido haya sido aceptado por
            el vendedor. Una cotización es válida por treinta (30) días o el período que se indique en
            ella. El vendedor se reserva explícitamente el derecho de retirar o enmendar una
            cotización en cualquier momento antes de su aceptación.
            Los envíos que sean más o menos de la cantidad realmente ordenada constituirán el
            cumplimiento del pedido si tal variación no excede los siguientes porcentajes: (i) 10% para
            pedidos de stock y personalizados cuando ETIMEX utiliza materias primas estándar; y (ii)
            20% para pedidos personalizados o donde ETIMEX usa materias primas no estándar. Un
            pedido puede ser cancelado o terminado solo con el consentimiento de ETIMEX y en
            términos que compensen completamente a ETIMEX por la pérdida (si la hubiera) debido a
            la cancelación o terminación.
            **5. ENVÍO, TÍTULO, RIESGO DE PÉRDIDA**
            A menos que ETIMEX confirme lo contrario en su reconocimiento de pedido de venta o en
            un acuerdo separado firmado por ETIMEX y el COMPRADOR, el envío es L.A.B. en el punto
            de envío de ETIMEX planta. El título y el riesgo de pérdida de todos los productos
            comprados pasarán al COMPRADOR al colocar los productos en un transportista común
            en el punto de envío de ETIMEX, independientemente de los términos de flete indicados o
            el método de pago de los cargos de transporte. ETIMEX se reserva el derecho de
            especificar el transportista y la ruta de los envíos.
            ETIMEX tiene la intención de enviar dentro del tiempo especificado en el reconocimiento
            del pedido de venta de ETIMEX, si se indica, y dicho tiempo es una estimación. Si no se
            especifica un tiempo, entonces ETIMEX enviará dentro de un plazo razonable. A menos
            que se especifique en el reconocimiento del pedido de venta de ETIMEX, los cargos de
            flete se pagarán por adelantado y se facturará. Como garantía colateral por el pago del
            precio de compra, el COMPRADOR otorga a ETIMEX un derecho de retención y un interés
            de garantía sobre todos los derechos, títulos e intereses del COMPRADOR sobre los
            Productos, dondequiera que se encuentren, y ya sea que existan actualmente o que
            surjan o se adquieran de vez en cuando, y en todos sus accesiones, sustituciones y
            reemplazos, así como todos los ingresos (incluidos los ingresos del seguro) de lo anterior.
            **6. DAÑOS EN TRÁNSITO Y PRODUCTOS NO CONFORMES**
            a) El COMPRADOR es responsable de recibir el envío completo tal como ha sido
            entregado, e inmediatamente al recibirlo en la ubicación del COMPRADOR, debe anotar
            en el albarán de entrega cualquier porción faltante o dañada del envío. Esto debe
            reportarse a ETIMEX dentro de 2 días naturales posteriores a la recepción del envío. Para
            reclamaciones por daños, el embalaje completo debe conservarse siguiendo las
            instrucciones de ETIMEX para su devolución u otra gestión, y hasta que la reclamación
            haya sido evaluada y se haya emitido una determinación y/o nota de crédito.
            b) Dentro de los 2 días naturales de la recepción del envío, debe informarse a ETIMEX de
            cualquier daño oculto o productos no conformes. Es necesario retener el embalaje
            completo hasta que se emita un informe de inspección por daños ocultos por parte del
            transportista, o hasta que el Producto no conforme pueda ser evaluado y ETIMEX
            proporcione instrucciones para la devolución u otra gestión del embalaje. Una
            determinación de crédito se realizará una vez que la reclamación haya sido evaluada. No
            se emitirá ningún crédito por reclamaciones realizadas después del período de 5 días
            naturales.
            c) La rapidez es de suma importancia (EL TIEMPO ES ESENCIAL para los plazos
            establecidos en la Sección 6 de estos Términos y Condiciones). Una inspección rápida, así
            como la presentación oportuna de la reclamación con todos los documentos necesarios,
            facilitará un arreglo rápido. NOTA: Sin la documentación adecuada, no se podrá emitir
            crédito.
            d) Para reclamaciones verificadas de daños en tránsito o Productos no conformes, ETIMEX
            puede, a su sola discreción, reemplazar el producto o reembolsar el precio de compra. Los
            recursos establecidos en la Sección 6 de estos Términos y Condiciones para daños en
            tránsito y Productos no conformes son los únicos y exclusivos recursos del COMPRADOR.
            Todas las reclamaciones deben ir acompañadas de los siguientes documentos: (i) copia
            del albarán de entrega con anotación de daños o faltas, y se debe incluir la fecha, hora y
            nombre del receptor; (ii) fotografía(s) de los bienes dañados; y (iii) enviar copia del informe
            de inspección al representante de reclamaciones de ETIMEX. CONSERVE COPIAS PARA
            SUS ARCHIVOS.
            En ninguna circunstancia, ETIMEX será responsable de cualquier daño o falta en envíos
            con pago a la entrega.
            **7. SOFTWARE** Cuando aplique.
            a) Estas disposiciones se aplicarán a la entrega de software estándar y/o hecho a medida
            por el Vendedor ("Software"), además de las disposiciones contenidas en estos Términos y
            Condiciones. Cualquier término adicional relacionado con el uso del Software se
            establecerá en una licencia de Software separada.
            b) La entrega incluye el Software relacionado con la aplicación, el sistema operativo, así
            como el manual correspondiente.
            c) A menos que se acuerde lo contrario, el COMPRADOR instalará el Software en sus
            instalaciones por su propia cuenta.
            d) El Vendedor no garantiza que el Software esté libre de defectos y/o errores.
            e) El Vendedor otorgará al COMPRADOR una licencia no exclusiva para el uso del Software
            en el dispositivo instalado. La licencia se terminará y expirará inmediatamente al finalizar
            el uso del Software o el retorno, transferencia o venta del equipo, o en caso de expiración o
            terminación del Acuerdo entre las partes por cualquier razón. El título del Software
            permanecerá en todo momento con el vendedor.
            f) El COMPRADOR tiene prohibido (i) hacer copias del Software, excepto una copia de
            archivo o respaldo, (ii) realizar ingeniería inversa o descompilar el Software, y/o (iii) hacer
            enmiendas o alteraciones al Software sin el consentimiento previo por escrito del
            Vendedor.
            g) El Software no incluye el código fuente. No se otorgan al COMPRADOR derechos
            relacionados con el código fuente del Software.
            h) A menos que se acuerde lo contrario, el Vendedor no proporcionará servicios de
            mantenimiento relacionados con el Software.
            i) El Vendedor puede, a su sola discreción, determinar en cualquier momento si
            proporcionar una nueva versión del Software al COMPRADOR o cualquier parche o
            corrección para el Software.
            **8. ARTE, ALTERACIONES, PRUEBAS Y ALMACENAMIENTO**
            a) Arte, placas y herramientas, incluidos todos los tipos de archivos electrónicos, placas o
            pantallas de impresión, grabados, películas, troqueles de corte o estampado, u otras
            herramientas, incluso si se ha cobrado una tarifa de uso o creación al COMPRADOR,
            seguirán siendo propiedad exclusiva de ETIMEX, a menos que se indique específicamente
            lo contrario en la propuesta de la estimación.
            b) Las propuestas son solo para trabajos según las especificaciones originales. Si por error
            del COMPRADOR, o cambio de opinión, el trabajo debe realizarse una segunda vez o más,
            ese trabajo adicional o las alteraciones llevarán un cargo adicional a las tarifas vigentes
            para el trabajo realizado.
            c) Las pruebas se deben enviar con la copia original. Las correcciones, si las hay, deben
            hacerse en el "Juego Maestro"
            , devueltas marcadas como "OK" o "OK con correcciones" y
            firmadas con el nombre o las iniciales de la persona debidamente autorizada para
            aprobarlas. Si se desean pruebas revisadas, la solicitud debe hacerse cuando se devuelvan
            las pruebas. ETIMEX lamenta cualquier error que pueda ocurrir durante la producción sin
            detectar, pero no puede hacerse responsable de errores si el trabajo se ha impreso según
            la aprobación del COMPRADOR o si se comunican cambios verbalmente. ETIMEX no será
            responsable de errores si el COMPRADOR no ha ordenado o ha rehusado aceptar pruebas,
            o no ha devuelto las pruebas con la indicación de cambios, o ha instruido a ETIMEX para
            proceder sin la presentación de pruebas.
            d) Las pruebas de prensa, a menos que se proporcionen específicamente en la cotización,
            se cobrarán a las tarifas vigentes. Se puede presentar una hoja de inspección de cualquier
            forma para la aprobación del COMPRADOR sin cargo, suponiendo que el COMPRADOR
            esté presente cuando la forma esté lista en la prensa para que no se pierda tiempo de
            prensa. Las prensas que esperan la aprobación del COMPRADOR o cualquier tiempo
            perdido debido a un cambio de opinión del COMPRADOR se cobrarán a las tarifas
            vigentes por el tiempo consumido.
            e) CONDICIONES DE ALMACENAMIENTO. Las etiquetas autoadhesivas, mangas termo
            encogibles y laminaciones deben almacenarse a 24°C ± -5 C°
            , y a 50% de humedad
            relativa ± 10%. El almacenamiento de las etiquetas en condiciones inferiores a estas hará
            que el rendimiento de las mangas, etiquetas y adhesivos sea dudoso. Las etiquetas
            almacenadas incorrectamente no llevarán ninguna garantía.
            **9. CUMPLIMIENTO**
            Los productos se fabrican en cumplimiento con todos los requisitos aplicables de la Ley de
            Normas Justas de Trabajo, según enmendada. Excepto que se acuerde lo contrario por
            escrito, las tolerancias normales en las especificaciones de ETIMEX no serán causa para
            rechazar productos.
            El COMPRADOR cumplirá con todas las Leyes y regulaciones Aplicables, incluidas, entre
            otras, las leyes y regulaciones pertinentes de la Unión Europea, Estados Unidos, Canadá y
            México sobre exportación y el COMPRADOR no exportará ni reexportará ningún dato
            técnico o Productos del Vendedor y/o sus filiales a ningún país, parte o entidad a la que la
            exportación o reexportación esté prohibida por la Unión Europea, Estados Unidos, Canadá
            y México. El COMPRADOR cumplirá con las disposiciones de cualquier ley anticorrupción
            aplicable, incluidas, entre otras, la Ley de Anticorrupción del Reino Unido, la "Ley de
            Prácticas Corruptas en el Extranjero" ("FCPA") de los Estados Unidos de América y la
            Convención de la OCDE para Combatir el Soborno de Servidores Públicos Extranjeros
            ("OCDE").
            **10. DEVOLUCIONES**
            Todos los Productos son retornables solo de acuerdo con las disposiciones de garantía en
            la Sección 11. Antes de devolver cualquier producto, el COMPRADOR debe obtener la
            aprobación previa por escrito y las instrucciones de ETIMEX.
            **11. GARANTÍA LIMITADA**
            TODAS LAS DECLARACIONES, INFORMACIONES Y RECOMENDACIONES (TÉCNICAS O
            DE OTRO TIPO) SOBRE LOS PRODUCTOS DEL VENDEDOR, Y EL USO O APLICACIÓN DE
            TALES PRODUCTOS, SE BASAN EN LA EXPERIENCIA Y PRUEBAS DEL VENDEDOR Y SE
            CONSIDERAN DE CONFIANZA, PERO NO CONSTITUYEN UNA GARANTÍA EXPRESA NI
            IMPLÍCITA SOBRE LA PRECISIÓN, INTEGRIDAD O RESULTADOS A OBTENER. TODOS LOS
            PRODUCTOS SE VENDEN Y LAS MUESTRAS SE PROPORCIONAN CON EL ACUERDO QUE
            EL COMPRADOR ASUME LA RESPONSABILIDAD ÚNICA E INDEPENDIENTE DE SU
            PROPIO CONTROL DE CALIDAD, PRUEBAS, PROCESO DE CALIFICACIÓN Y
            DETERMINACIÓN DE LA IDONEIDAD DE LOS PRODUCTOS PARA CUALQUIER USO O
            PROPÓSITO PREVISTO.
            Todos los productos nuevos tienen una garantía de (90) días naturales* desde la fecha de
            fabricación deben estar libres de defectos en materiales o mano de obra, de modo que los
            Productos cumplan con las especificaciones de ETIMEX. Esta garantía se aplica
            únicamente al COMPRADOR original de los Productos y no crea derechos u obligaciones
            para ningún tercero. Todos los Productos reacondicionados tendrán una garantía de
            treinta (30) días desde la fecha de instalación y aplicación. Dicha garantía es aplicable a
            Productos instalados, equipos o servicios, si dicha instalación es realizada por un
            representante autorizado de ETIMEX. Una vez que se determine a satisfacción del
            VENDEDOR que los Productos fueron almacenados y utilizados por el COMPRADOR de
            acuerdo con los estándares aplicables sugeridos por el Vendedor (si los hay) y no dañados
            durante el transporte, el único y exclusivo remedio del COMPRADOR por incumplimiento
            de esta garantía será la sustitución de los Productos defectuosos o, a opción del
            VENDEDOR, la emisión de un crédito o reembolso de una cantidad de hasta el precio de
            compra del Producto defectuoso. En ningún caso el VENDEDOR será responsable de
            reclamaciones más allá del precio de compra del Producto defectuoso. El COMPRADOR
            mantendrá la trazabilidad de los productos convertidos para confirmar que una
            reclamación se basa en el producto real del vendedor, y la falta de trazabilidad puede
            resultar en la denegación de una reclamación en su totalidad o en parte.
            LA GARANTÍA ESPECIFICADA EN ESTA SECCIÓN 11 ES EN LUGAR DE CUALQUIER OTRA
            GARANTÍA, EXPRESA O IMPLÍCITA, INCLUIDAS, ENTRE OTRAS, GARANTÍAS DE
            COMERCIABILIDAD, IDONEIDAD PARA CUALQUIER PROPÓSITO PARTICULAR Y/O NO
            INFRACCIÓN, YA SEA EXPRESA O IMPLÍCITA POR LEY, CURSO DE TRATO, CURSO DE
            RENDIMIENTO, USO COMERCIAL O DE OTRO TIPO. ETIMEX ESPECÍFICAMENTE
            RENUNCIA Y EXCLUYE TODAS ESAS OTRAS GARANTÍAS.
            Ningún representante o agente de ETIMEX está autorizado a dar ninguna garantía o
            representación contraria a los términos y condiciones aquí, a menos que sea por escrito y
            firmado manualmente por un funcionario de ETIMEX.
            *O el período de tiempo declarado en la especificación o hoja de datos publicada del Producto, si la hubiera,
            vigente en el momento del envío.
            **12. NOTIFICACIÓN DE RECLAMACIONES**
            Todas las reclamaciones por un supuesto incumplimiento de la garantía bajo la Sección 11
            deberán hacerse por escrito y enviarse por correo certificado o registrado. No se
            permitirán reclamaciones si se hacen más de veinte (20) días después de que el
            COMPRADOR se entere o debería haberse enterado del supuesto defecto que da lugar a
            la reclamación. No se podrán devolver mercancías a ETIMEX excepto por dicho supuesto
            incumplimiento de garantía y a menos que el COMPRADOR haya dado la notificación
            adecuada de la reclamación y ETIMEX haya emitido autorización de devolución. En caso
            de que se determine que ETIMEX no tiene responsabilidad con respecto a dicha
            reclamación, el COMPRADOR será responsable de los costes de ETIMEX por el manejo y
            almacenamiento de las mercancías devueltas.
            **13. INSTALACIÓN**
            Si es aplicable, la instalación de Productos comprados bajo este Acuerdo se realizará
            únicamente por representantes autorizados de ETIMEX. ETIMEX no tendrá
            responsabilidad por interrupciones en los locales y estructuras existentes que resulten de
            la instalación, ni por la instalación realizada de acuerdo con las instrucciones, planes o
            diseños proporcionados por el COMPRADOR.
            A solicitud del COMPRADOR, ETIMEX incluirá, como asegurado adicional, en las pólizas de
            seguro de ETIMEX a aquellos propietarios de propiedades que no sean parte de los
            Términos y Condiciones de Venta, pero donde ETIMEX deberá instalar su Producto o
            equipo en la ubicación del COMPRADOR. Esto se aplicará solo a esos propietarios de
            propiedades donde ETIMEX estará prestando servicios al COMPRADOR en las
            instalaciones.
            **14. LIMITACIÓN DE RESPONSABILIDAD**
            EN RELACIÓN CON LOS PRODUCTOS, LA VENTA DE PRODUCTOS O CUALQUIER
            CONTRATO DE VENTA DE PRODUCTOS, Y EN RELACIÓN CON CUALQUIER TIPO DE
            SERVICIO PROPORCIONADO POR EL VENDEDOR AL COMPRADOR (TALES COMO
            SERVICIOS TÉCNICOS, SOFTWARE, CONSULTORÍAS Y RESPUESTAS A CONSULTAS SOBRE
            PRODUCTOS O RECLAMACIONES), NINGUNA RECLAMACIÓN DEL COMPRADOR DE
            NINGÚN TIPO, Y NINGUNA RESPONSABILIDAD DE ETIMEX DE NINGÚN TIPO, SERÁ
            MAYOR EN CANTIDAD QUE EL PRECIO DE COMPRA DE LOS PRODUCTOS O SERVICIOS
            RESPECTO A LOS CUALES SE RECLAMAN DAÑOS. EL ÚNICO Y EXCLUSIVO REMEDIO DEL
            COMPRADOR ES LA REEMPLAZO DEL PRODUCTO O LA ACREDITACIÓN DEL PRECIO DE
            COMPRA, A LA DISCRECIÓN DEL VENDEDOR. TODAS LAS RECLAMACIONES, DEMANDAS
            O ACCIONES LEGALES NO PRESENTADAS POR EL COMPRADOR DENTRO DE UN AÑO
            DESDE LA FECHA EN QUE HAYA OCURRIDO UNA CAUSA DE ACCIÓN SE RENUNCIAN Y
            SON EXCLUIDAS.
            EL VENDEDOR NO TENDRÁ NINGUNA RESPONSABILIDAD EN ABSOLUTO POR DAÑOS
            ESPECIALES, INCIDENTALES, INDIRECTOS, PUNITIVOS, EJEMPLARES O
            CONSECUENCIALES (NI POR DAÑOS POR LESIONES A PERSONAS O PROPIEDADES,
            INTERRUPCIÓN DEL NEGOCIO, DISMINUCIÓN EN EL VALOR Y PÉRDIDAS DE
            BENEFICIOS, INDEPENDIENTEMENTE DE SI LOS DAÑOS SE CARACTERIZAN COMO
            DAÑOS DIRECTOS O CONSECUENCIALES O DE OTRO MODO) YA SEA POR
            INCUMPLIMIENTO DE CONTRATO, AGRAVIO (INCLUYENDO NEGLIGENCIA) O DE OTRO
            MODO, Y SEA O NO QUE DICHOS DAÑOS FUERAN PREVISIBLES O SI EL VENDEDOR
            HABÍA SIDO ADVERTIDO DE LA POSIBILIDAD DE DICHOS DAÑOS, Y A PESAR DEL
            FRACASO DE CUALQUIER REMEDIO ACORDADO U OTRO PARA SUS PROPÓSITOS
            ESENCIALES.
            **15. PROPIEDAD INTELECTUAL**
            a) Todos los derechos de propiedad intelectual relacionados con los Productos serán y
            seguirán siendo propiedad intelectual del Vendedor o de sus licenciatarios.
            b) Todos los logotipos, nombres comerciales o marcas del COMPRADOR que el
            COMPRADOR posea o use en el curso de su negocio ("Marcas") son propiedad exclusiva
            del COMPRADOR y el COMPRADOR retendrá los derechos de propiedad intelectual en
            relación con el uso de dichas Marcas. En caso de que esto sea requerido para el
            cumplimiento de las obligaciones bajo el Acuerdo y/o estas Condiciones, el COMPRADOR
            otorgará al Vendedor una licencia gratuita y no exclusiva para usar las Marcas durante el
            plazo del Acuerdo o hasta que las obligaciones del Vendedor, incluidos los períodos para
            cumplir con obligaciones de cumplimiento y normativas bajo estas Condiciones, hayan
            sido cumplidas. El COMPRADOR indemnizará y mantiene al vendedor libre de cualquier
            coste (como, pero no limitado a reclamaciones de terceros, demandas, responsabilidades,
            pérdidas, daños, acuerdos, sentencias) que pueda ser sostenido o incurrido por el
            Vendedor en relación con, o como resultado del uso de las Marcas, si y en la medida que
            dicho uso de las Marcas sea prescrito por el COMPRADOR en relación con el Acuerdo y/o
            estas Condiciones.
            c) Salvo que se disponga expresamente en el Acuerdo o en estas Condiciones, ninguna
            cláusula en el Acuerdo ni en las Condiciones se interpretará como que otorga o implica al
            COMPRADOR ningún derecho sobre el Producto bajo cartas de patente u otro derecho de
            propiedad intelectual. Si los Productos van a ser modificados en cualquier proceso de
            fabricación o combinados con otros componentes donde el Producto, cambiado o
            producido de acuerdo con una especificación emitida por el COMPRADOR, el
            COMPRADOR indemnizará y defenderá al Vendedor contra toda pérdida, daños, costes y
            gastos adjudicados contra o incurridos por el Vendedor en relación con o pagados o
            acordados ser pagados por el Vendedor en la liquidación de cualquier reclamación por
            infracción de cualquier patente, copyright, diseño registrado, marca registrada u otros
            derechos de propiedad industrial o intelectual de cualquier otra persona que resulten del
            uso hecho por el Vendedor de la especificación, modificación o combinación del
            COMPRADOR donde el Producto en sí mismo no estaría sujeto a ninguna reclamación de
            infracción.
            d) El Vendedor tendrá el derecho de imprimir su nombre y cualquier información
            aplicable de copyright, marca registrada o patente sobre los Productos, excepto que el
            COMPRADOR pueda, antes de la fabricación de productos por pedido especial..
            **16. PROPIEDAD DEL COMPRADOR**
            ETIMEX puede cobrar al COMPRADOR, a las tarifas vigentes, por el manejo y
            almacenamiento de existencias del COMPRADOR o material impreso del COMPRADOR
            almacenado por más de treinta (30) días. Sin un acuerdo específico que indique lo
            contrario, toda propiedad del COMPRADOR almacenada con ETIMEX está bajo el riesgo
            del COMPRADOR y ETIMEX no es responsable por ninguna pérdida o daño a la misma
            causado por incendio, filtración de agua, robo, negligencia, insectos, roedores o cualquier
            causa más allá del control razonable de ETIMEX. Los trabajos artísticos, en su forma
            original, proporcionados por el COMPRADOR a ETIMEX, se consideran propiedad del
            COMPRADOR. Se entiende que el almacenamiento gratuito de la propiedad del
            COMPRADOR es exclusivamente para el beneficio del COMPRADOR.
            **17. RECALLS **
            a) Si el Vendedor se ve obligado o solicitado por alguna autoridad gubernamental a retirar
            cualquier Producto o decide hacerlo voluntariamente porque dichos Productos pueden
            violar cualquier ley o por cualquier otra razón, el COMPRADOR deberá cooperar
            plenamente con el Vendedor en relación con cualquier retirada de mercado, incluyendo,
            pero no limitándose a la cesación de su propia distribución. No se harán comunicados de
            prensa, entrevistas o declaraciones sin la aprobación previa por escrito del Vendedor.
            b) Si la retirada se debe a actos u omisiones negligentes del COMPRADOR en el manejo,
            almacenamiento o empaque del Producto o a la falta del COMPRADOR de cumplir con las
            Leyes Aplicables, o con las especificaciones del COMPRADOR, entonces el COMPRADOR
            estará obligado a asumir y llevar a cabo la retirada de los Productos y todos los costos y
            gastos de la retirada serán asumidos por el COMPRADOR, quien indemnizará y
            mantendrá indemne al Vendedor contra todas las reclamaciones y demandas
            relacionadas con la retirada.
            **18. CESIÓN**
            Los derechos y obligaciones de ETIMEX y del COMPRADOR relacionados con la compra y
            venta de Productos de ETIMEX serán vinculantes, redundará en beneficio y serán exigibles
            por ETIMEX y el COMPRADOR y sus respectivos herederos, legatarios, representantes
            legales, sucesores y cesionarios. El COMPRADOR no puede ceder ninguno de sus
            derechos u obligaciones bajo estos Términos y Condiciones sin el consentimiento previo
            por escrito de ETIMEX.
            **19. NO RENUNCIA**
            Ninguna renuncia por parte del VENDEDOR de cualquiera de las disposiciones de estos
            Términos y Condiciones será efectiva a menos que se establezca explícitamente por
            escrito y sea firmada manualmente por un oficial de ETIMEX. Ninguna falta de ejercicio o
            demora en el ejercicio de cualquier derecho, remedio, poder o privilegio derivado de estos
            Términos y Condiciones se interpretará como una renuncia a los mismos. Ningún ejercicio
            único o parcial de cualquier derecho, remedio, poder o privilegio bajo estos Términos y
            Condiciones excluye cualquier otro o futuro ejercicio de cualquier derecho, remedio,
            poder o privilegio.
            **20. FUERZA MAYOR**
            El VENDEDOR no será responsable ante el COMPRADOR, ni se considerará que ha
            incumplido estos Términos y Condiciones, por cualquier retraso o incumplimiento en el
            cumplimiento o ejecución de cualquier venta, contrato de venta, envío, servicio, o
            cualquier otro asunto en relación con la venta y el envío de Productos o estos Términos y
            Condiciones en la medida en que dicho incumplimiento o retraso sea causado por o
            resulte de (1) circunstancias, causas o contingencias fuera del control razonable del
            VENDEDOR, incluidos, aunque no limitados a, los enumerados en el punto (2) de esta
            Sección 13, o (2) cambios en los horarios de envío, accidentes, incendios, huelgas, cierres
            patronales u otros conflictos laborales, enfermedades o epidemias, disturbios, conmoción
            civil, insurrección, guerra, actos terroristas, elementos naturales, embargos, fallos del
            transportista, fluctuación de moneda, devaluaciones, incapacidad para obtener
            instalaciones de transporte, incapacidad o retraso para obtener materiales adecuados o
            suficientes, cortes de telecomunicaciones o electricidad, requisitos gubernamentales,
            actos de Dios o enemigos públicos, pedidos previos de otros, o limitaciones en los
            productos o actividades de marketing de ETIMEX o sus proveedores.
            **21. ELECCIÓN DE LEY**
            Cualquier y toda disputa que surja de o esté relacionada con estos Términos y
            Condiciones, los Productos, las ventas y contratos de venta de Productos, o las relaciones
            entre las partes se regirá, interpretará y ejecutará de acuerdo con las leyes del Estado de
            Nuevo León, sin dar efecto a las disposiciones o estatutos de Elección o conflicto de leyes
            de estado de Nuevo León, México de cualquier otro estado.
            **22. ACUERDO COMPLETO**
            Estos Términos y Condiciones y la confirmación o acuse de recibo de pedido de venta de
            ETIMEX representan el acuerdo final y completo entre ETIMEX y el COMPRADOR en
            relación con los temas aquí incluidos, y están destinados a ser una declaración completa y
            exclusiva de los términos y condiciones del acuerdo con respecto a los Productos y la
            venta de Productos como se establece en la orden de venta de ETIMEX.

          `}</p>
          {/* <p className="mb-4">
            We use your data to provide, improve, and personalize our services, contact you about our services, provide
            you with personalized advertising and marketing, and detect, prevent, mitigate, and investigate fraudulent
            or illegal activities.
          </p>
          <p className="mb-4">
            You have rights and choices with respect to your personal data and can access, correct, and delete your
            personal data, subject to exceptions. We will not disclose your personal data to third parties for their
            marketing and advertising purposes without your explicit consent.
          </p> */}
        </Grid>
        <div>
          <Button className="w-full ">
            <Link to="/#inicio" >
              Regresar
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}

